/** @format */

import template from './gb-fullscreen-overlay.html';
import './gb-fullscreen-overlay.scss';

export const GbFullscreenOverlayComponent = {
    template,
    require: {
        gbPresenter: '^^',
    },
    controller: class GbFullscreenOverlayComponent {
        constructor($timeout) {
            'ngInject';

            this.$timeout = $timeout;
        }

        showEditTools() {
            this.gbPresenter.isFullscreen = false;
            this.showingOverlay = false;

            this.gbPresenter.exitFullscreen();

            if (this.$revealingTimeout) {
                this.$timeout.cancel(this.$revealingTimeout);
                this.$revealingTimeout = null;
            }
        }

        revealOverlay() {
            this.showingOverlay = true;

            if (this.$revealingTimeout) {
                this.$timeout.cancel(this.$revealingTimeout);
            }

            this.$revealingTimeout = this.$timeout(() => {
                this.showingOverlay = false;
                this.$revealingTimeout = null;
            }, 1000);
        }

        $onDestroy() {
            if (this.$revealingTimeout) {
                this.$timeout.cancel(this.$revealingTimeout);
                this.$revealingTimeout = null;
            }
        }
    },
};
